import React, {useState, useEffect} from 'react'
import { Title } from '../../../components/JurosCompostos/Title'
import { Button } from '../../../components/JurosCompostos/Button'
import { AdvancedChart } from '../../../components/RendaFixa/AdvancedChart'
import style from './style.module.scss'
import { Label } from '../../../components/JurosCompostos/Label'
import { Switch } from '../../../components/JurosCompostos/Switch'

export const Advanced = (props) => {
  const [rentabilidadesChart, setRentabilidadesChart] = useState([])

  useEffect(()=>{
    if(rentabilidadesChart.length === 0){
      setRentabilidadesChart(props.rentabilidadesChart)
    }
  }, [props.rentabilidadesChart])

  // Atualiza o valor de rentabilidade com as alerações feitas no gráfico do menu avançado
  function utualizaRentabilidades(value){
    props.utualizaRentabilidades(value)
  }

  return (
    <div className={style.main}>
        <div className={style.calculator}>
          <Title>Avançado</Title>
          <div className={style.subTitle}>Altere os índices futuros arrastando os pontos do gráfico.
          <br />Os gráficos consideram os valores exatos setados de um ponto a outro da coluna</div>
          <div>
            {(rentabilidadesChart.length > 0)?
              <div className={style.chart}>
                <div className={style.chartTitle}>IPCA</div>
                <AdvancedChart data={[rentabilidadesChart[0]]} maxValue={10} minValue={0} onChange={utualizaRentabilidades}/>
              </div>
            :null}
            {(rentabilidadesChart.length > 0 && props.showSelic)?
              <div className={style.chart}>
                <div className={style.chartTitle}>
                  SELIC
                  <Label tooltip={true} tooltipText={'Ao ajustar o índice Selic no gráfico,<br />os investimentos baseados na CDI serão também alterados.'} autosize={true}></Label>
                </div>
                <AdvancedChart data={[rentabilidadesChart[2]]} maxValue={10} minValue={0} onChange={utualizaRentabilidades}/>
              </div>
            :null}
          </div>
          <div className={style.switch}>
            <div className={style.switchTitle}>Formato do Valor Total</div>
            <Switch firstOption={'NOMINAL'} secondOption={'REAL'} activeInit={(props.resultType === 'real')?true:false} onCLick={props.handleSwitchOnClick} styleVersion={2}/>
          </div>
          <div className={style.buttons}>
            <div>
              <Button onClick={()=>{setRentabilidadesChart([]); props.cancelButton()}} white={true}>CANCELAR</Button>
            </div>
            <div>
              <Button onClick={()=>{setRentabilidadesChart([]); props.calculateButton()}}>APLICAR</Button>
            </div>
          </div>
        </div>
    </div>
  )
}
